Vue.component("Hotspot", {
    props: ["hotspot", "index", "settings", "resetHotspot", "activeHotspot"],
    template: `
    <transition :name="getHotspotEntrance">
        <li class="hotspot" 
            v-if="hotspotShown"
            :class="[getHotspotType, {'hotspot--notext': hotspot.title == ('' || undefined)}, {'hotspot--flipped': isHotspotFlipped}, setHotspotLockedClass]"
            :style="[getHotspotPosition, getHotspotColor, getCustomWidth]"
            @click="goto(hotspot); onClickAnimation();">

            <h2 v-html="hotspot.title"></h2>
        </li>
    </transition>
`,
    data() {
        return {
            // variables for this instance of the hotspot
            hotspotShown: false,
            minDelay: 4,
            maxDelay: 30,
            animatingClick: false,

            //global variables for hotspots
            hotspotType: this.settings.hotspotType,

            loopAnimationType: this.settings.loopAnimationType,
            clickAnimationType: this.settings.clickAnimationType,

            animationCycleStyle: this.settings.animationCycleStyle,
            animationCycleEnabled: true,
            isHotspotLocked: false,
            get completedHotspots() {
                return app.localStore.get("hotspots-completed").completed || []
            }
        }
    },
    methods: {
        goto(hotspot) {
            // Call goto() in PageScene
            this.$emit("goto", hotspot);
        },
        getRandomAnimationDelay(min, max) {
            //return a random value for random animations
            return Math.random() * (max - min) + min;
        },
        onClickAnimation() {
            // set the hotspot to animate as feedback if the hotspot is pressed
            if (this.animatingClick == false)
                this.animatingClick = true;
            setTimeout(() => {
                this.animatingClick = false;
                this.$emit("resetHotspotAnimationCycle");
            }, 1500);
        },
        hotspotEntrance() {
            //handler for the entrance of hotspots when scene is loaded.
            // load in one by one, depending on their position in the hotspots array of the scene
            let delay = 0;
            delay = (this.index * 400) + 600;

            setTimeout(() => {
                this.hotspotShown = true;
            }, delay);
        },
        getAnimationCycleStyle() {
            // helper for assigning animation cycle style from the config.js
            switch (this.animationCycleStyle) {
                case "random":
                    return this.getRandomAnimationDelay(this.minDelay, this.maxDelay).toFixed(1) + 's'
                case "pulse":
                    return ((this.index * 0.1) + 1.5) + "s"
            }
        },

        isHotspotLockedCheck() {
            if (!this.hotspot.data.neededForUnlock)
                return


            let isSaved = false;
            isSaved = this.completedHotspots.find(a => {
                if (a == this.hotspot.data.neededForUnlock) {
                    return true;
                }
            })


            this.isHotspotLocked = isSaved === undefined ? true : false
        }
    },
    created() {},
    mounted() {
        this.eventHandlers = {};
        this.eventHandlers["hotspot-animation-cycle-disable"] = () => {
            this.animationCycleEnabled = false;
        }
        this.eventHandlers["hotspot-animation-cycle-enable"] = () => {
            this.animationCycleEnabled = true;
        }

        this.isHotspotLockedCheck();
        window.addEventListener('hotspotcompleted', (event) => {
            this.isHotspotLockedCheck();
        }, false);
        app.radio.$on("hotspot-animation-cycle-disable", this.eventHandlers["hotspot-animation-cycle-disable"]);
        app.radio.$on("hotspot-animation-cycle-enable", this.eventHandlers["hotspot-animation-cycle-enable"]);

        this.hotspotEntrance();
    },
    beforeDestroy() {},
    destroyed() {
        window.removeEventListener('hotspotcompleted', (event) => {
            this.isHotspotLockedCheck();
        }, false);
        app.radio.$off("hotspot-animation-cycle-disable", this.eventHandlers["hotspot-animation-cycle-disable"]);
        app.radio.$off("hotspot-animation-cycle-enable", this.eventHandlers["hotspot-animation-cycle-enable"]);
    },
    computed: {
        getHotspotPosition() {
            if (this.isHotspotFlipped) {
                return {
                    right: this.hotspot.x + 'px',
                    top: this.hotspot.y + 'px'
                }
            } else {
                return {
                    left: this.hotspot.x + 'px',
                    top: this.hotspot.y + 'px'
                }
            }

        },
        getHotspotColor() {
            if (this.hotspot.data.hotspotColor !== "")
                return {
                    background: this.hotspot.data.hotspotColor
                }
        },
        getCustomWidth() {
            if(this.hotspot.data.customHotspotWidth !== 0) {
                return {
                    width: this.hotspot.data.customHotspotWidth + 'px'
                }
            }
        },
        isHotspotFlipped() {
            return this.hotspot.hotspotstyle.hasOwnProperty('flipped') && this.hotspot.hotspotstyle.flipped === true
        },
        getHotspotType() {
            // assign Link as hot spot type if hotspot has any other hotspot children elements in manifest.
            // else assign the given type.
            if (this.hotspot.hotspots == true) {
                return "linkhotspot"
            } else {
                return this.hotspot.type
            }
        },
        getContinuousHotspotAnimation() {
            // assign the looping animation on hotspots, as well as keeping them synced with resetHotspot.
            if (this.resetHotspot == true) {
                return
            } else if (!this.animationCycleEnabled) {
                return;
            } else if (this.isHotspotLocked) {
                return {
                    'animation-name': 'animateLock',
                    'animation-iteration-count': 'infinite',
                    'animation-duration': '25s',
                    'animation-delay': this.getAnimationCycleStyle()
                }
            } else {
                return {
                    'animation-name': this.loopAnimationType,
                    'animation-iteration-count': 'infinite',
                    'animation-duration': '15s',
                    'animation-delay': this.getAnimationCycleStyle()
                }
            }
        },
        getClickHotspotAnimation() {
            // Assign the click animation when hotspot is clicked.
            if (this.animatingClick) {
                return {
                    'animation-name': this.clickAnimationType,
                    'animation-iteration-count': '1',
                    'animation-duration': '1.5s',
                    'animation-delay': '0s'
                }
            } else {
                return
            }
        },

        getHotspotEntrance() {
            if (!this.isHotspotFlipped) {
                return "hotspotEntranceLeft"
            } else {
                return "hotspotEntranceRight"
            }
        },
        setHotspotLockedClass() {
            return {
                'hotspot--locked': this.isHotspotLocked
            }
        }
    }
})